export default function Footer() {
  return (
    <footer style={{ background: '#C4622D' }}>
      <div
        className="max-w-6xl mx-auto px-6 md:px-10 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
        style={{ color: '#FAF6EE' }}
      >
        <p className="font-display text-[18px] md:text-[20px] tracking-wide">
          RITIKA GHOSH <span className="opacity-80 text-[14px]">© 2026</span>
        </p>
        <p className="text-[12.5px] tracking-[0.18em] uppercase opacity-90">
          Assistant Manager - UI/UX <span style={{ color: '#2A1F14' }}>·</span> Mumbai
        </p>
      </div>
    </footer>
  );
}
